import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import TranslationUtils from 'Utils/TranslationUtils';
import { Helmet } from 'react-helmet';
import EmailIcon from '../../../Assets/email.svg';
import PiplLogo from '../../../Assets/pipl.svg';
import { AppSelectors } from '../../../Redux/modules/app/selectors';
import styles from './EmailConfirm.module.less';
import { VettingActions } from '../../../Redux/modules/vetting/actions';

const EmailConfirmation = ({ confirmEmail, resendConfirmationEmail }) => {
  const resendEmail = () => {
    resendConfirmationEmail({ email: confirmEmail });
  };
  return (
    <div className={styles.container}>
      <Helmet>
        <title>{gettext('Confirm Email')}</title>
      </Helmet>
      <div className={styles.logoWrapper}>
        <a href="https://pipl.com">
          <img src={PiplLogo} alt="" width="80" height="49" />
        </a>
      </div>
      <div className={styles.titleWrapper}>
        <h3 className={styles.title} test-id="page-title">
          {TranslationUtils.getText('EMAIL_CONFIRM_PAGE_TITLE')}
        </h3>
      </div>

      <div className={styles.body}>
        <span className={styles.paragraph}>{TranslationUtils.getText('EMAIL_CONFIRM_PAGE_BODY_PART_ONE')}</span>
        <span className={styles.paragraph}>{TranslationUtils.getText('EMAIL_CONFIRM_PAGE_BODY_PART_TWO')}</span>
        <span className={styles.email}>{confirmEmail}</span>
      </div>

      <div className={styles.imageFooter}>
        <img src={EmailIcon} alt="" width="237" height="97" />
      </div>

      <div className={styles.footer}>
        <div className={styles.resend}>
          <span>{gettext("Didn't receive an email?")}</span>
          <a className={styles.link} onClick={() => resendEmail()} role="link" aria-label="Main" tabIndex="-1">
            {gettext('Click to resend')}
          </a>
        </div>
        <a className={styles.footerLink} href="https://pipl.com/">
          <span className={styles.footerUrl}>{TranslationUtils.getText('EMAIL_CONFIRM_PAGE_FOOTER')}</span>
        </a>
      </div>
    </div>
  );
};

EmailConfirmation.propTypes = {
  confirmEmail: PropTypes.string,
  resendConfirmationEmail: PropTypes.func,
};

const mapDispatchToProps = {
  resendConfirmationEmail: VettingActions.resendConfirmationEmail,
};

const mapStateToProps = (state) => {
  return {
    confirmEmail: AppSelectors.onBoardingConfirmEmailSelector(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailConfirmation);
